import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { CoverComponent } from './pages/cover/cover.component';
import { AnkitVermaComponent } from './pages/ankit-verma/ankit-verma.component';
import { BishakhaDuttaComponent } from './pages/bishakha-dutta/bishakha-dutta.component';
import { HalfSareeComponent } from './pages/half-saree/half-saree.component';
import { GulaboSitaboComponent } from './pages/gulabo-sitabo/gulabo-sitabo.component';
import { NetflixComponent } from './pages/netflix/netflix.component';
import { ArtOfCriticismComponent } from './pages/art-of-criticism/art-of-criticism.component';
import { BreguetComponent } from './pages/breguet/breguet.component';
import { ChanelComponent } from './pages/chanel/chanel.component';
import { MentalHealthComponent } from './pages/mental-health/mental-health.component';
import { GucciComponent } from './pages/gucci/gucci.component';
import { AnimationComedyComponent } from './pages/animation-comedy/animation-comedy.component';
import { BollywoodSubtextComponent } from './pages/bollywood-subtext/bollywood-subtext.component';
import { ForewordComponent } from './pages/foreword/foreword.component';

const routes: Routes = [
  // {path: '',component: HomeComponent,pathMatch: 'full'},
  { path: 'home', redirectTo: '' },
  { path: '', component: HomeComponent, pathMatch: 'full' }, // 0
  { path: 'anjali-patil-cover-story', component: CoverComponent }, // 1
  { path: 'netflix-india-storytelling', component: NetflixComponent }, // 2
  { path: 'gulabo-sitabo-masculinity', component: GulaboSitaboComponent }, // 3
  { path: 'contemporary-film-reviewing', component: ArtOfCriticismComponent }, // 4
  { path: 'half-sari-malayalam-cinema', component: HalfSareeComponent }, // 5
  { path: 'bishakha-datta-sex-gaze', component: BishakhaDuttaComponent }, // 6
  { path: 'performance-art-ankit-verma', component: AnkitVermaComponent }, // 7
  { path: 'queer-intimacy-hindi-songs', component: BollywoodSubtextComponent }, // 8
  { path: 'vasu-primlani-animated-comedy', component: AnimationComedyComponent }, // 9
  { path: 'mental-health-indian-films', component: MentalHealthComponent }, // 10
  { path: 'gucci-nick-cave', component: GucciComponent }, // 11
  { path: 'gabrielle-chanel-costume-design', component: ChanelComponent }, // 12
  { path: 'breguet-marine-haute-joaillerie', component: BreguetComponent }, // 13
  { path: 'about-us', component: ForewordComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    scrollPositionRestoration: "top"
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
